import React, {useContext, useState} from 'react';
import {DialogContent, FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ModalDialog from "./ModalDialog";
import {inputStyles} from "../shared";
import TextField from '@material-ui/core/TextField';
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {BackendContext} from "./BackendContext";

const useStyles = makeStyles({input: inputStyles});

export type Props = {
    open?: boolean
    onCancel: () => void
    onSelect: (salesTaxPercent: number) => void
}

function SalesTaxDialog({onCancel, onSelect, open = false}: Props) {
    const [zipCode, setZipCode] = useState(""),
        [loadRegions, setLoadRegions] = useState(true),
        [regions, setRegions] = useState<any[]>([]),
        [regionIndex, setRegionIndex] = useState<any>(""),
        region = regions[regionIndex],
        backend = useContext(BackendContext),
        classes = useStyles();

    return (
        <ModalDialog open={open} onClose={onCancel}
                     title="Estimate Sales Tax"
                     content={<>
                         <DialogContent>
                             {/*<Typography variant="body2" component="p" color="secondary">
                                 We'll get back to you within 24 hours to get more details about your potential new home!
                             </Typography>*/}
                             <Grid container spacing={2} style={{marginTop: '1rem'}}>
                                 <Grid item xs={12}>
                                     <TextField value={zipCode} onChange={e => {
                                         setZipCode(e.target.value);
                                         setLoadRegions(true);
                                     }}
                                                label="Zip Code" fullWidth autoFocus
                                                className={classes.input}/>
                                 </Grid>
                                 <Grid item xs={12}>
                                     {loadRegions
                                         ? <Button onClick={async () => {
                                             if(zipCode) {
                                                 const resp = await backend.getSalesTax(zipCode);
                                                 console.log("Loading Regions...");
                                                 setLoadRegions(false);
                                                 setRegions(resp.results);
                                                 // setRegions([{geoCity: "TEST CITY", geoState: "STATE", taxSales: 0.0123}])
                                             }
                                         }}>Load Regions</Button>
                                         : <FormControl fullWidth>
                                             <InputLabel id="region-label">Region</InputLabel>
                                             <Select
                                                 labelId="region-label"
                                                 id="region"
                                                 value={regionIndex}
                                                 onChange={e => {
                                                     console.log("e", e.target.value, parseInt(e.target.value+''));
                                                     setRegionIndex(parseInt(e.target.value+''));
                                                 }}>
                                                 <MenuItem value="">
                                                     <em>None</em>
                                                 </MenuItem>
                                                 {regions.map((r,i) =>
                                                     <MenuItem key={i} value={`${i}`}>{r.geoCity}/{r.geoState}</MenuItem>)}
                                             </Select>
                                         </FormControl>}
                                 </Grid>
                             </Grid>
                         </DialogContent>
                     </>}
                     actions={<>
                         <Button color="primary" onClick={() => {
                             onCancel();
                         }}>Back</Button>
                         <Button color="primary" variant="contained"
                                 onClick={() => onSelect(region?.taxSales || 0)}>
                             Select
                         </Button>
                     </>}/>
    );
}

export default SalesTaxDialog;